import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { globals } from '../../../environments/globals';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-categories',
    standalone: true,
    styleUrls: ['./categories.page.scss'],
    templateUrl: './categories.page.html',
})

export class CategoriesPage implements OnInit {
  selectedCategory: any;
  groupings: any = globals.groupings;
  classifications: any = globals.classifications;

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Categories: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Categories and classifications for 39 countries in our global Future of Work gig economy jobs volunteer marketplace across 39 countries in Australia, Austria, Belgium, Bulgaria, Canada, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hong Kong, Hungary, Ireland, Italy, Japan, Latvia, Lithuania, Luxembourg, Malaysia, Malta, Netherlands, New Zealand (NZ), Norway, Peru, Poland, Portugal, Romania, Singapore, Slovakia, Slovenia, Spain, Sweden, Switzerland, United Arab Emirates (UAE), United Kingdom (UK) & United States of America (USA).' }
    )
  }

  onSelected(value :any) {
    if (this.selectedCategory == value) {
      this.selectedCategory = '';
    } else {
      this.selectedCategory = value;
    }
  }
}
